import React from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from 'antd'
import {DASH} from '../../helpers/format'

/**
 * Mã thao tác dẫn tới một công đoạn — hiện ĐỦ, kể cả khi có nhiều hơn một.
 *
 * ⚠️ Đọc `actionCodes` (mảng) chứ KHÔNG đọc `actionCode` (một giá trị). Đóng thùng tới được bằng hai
 *    đường — `updated_status_packaged` và `updated_status_manual-package` — và service đã cộng cả hai
 *    vào sản lượng từ 28/09/2026. Hiện mỗi mã đầu là màn hình nói sai về chính cấu hình đang chạy:
 *    người dùng đọc thấy một mã, đi đối chiếu log, thấy sản lượng cao hơn mã đó, rồi báo lỗi tính
 *    sai — đúng vòng lặp mà FAC-25763 vừa gỡ ra.
 *
 * `actionCode` đơn lẻ vẫn được nhận làm đường lui: BE bản trước 29/09 chưa trả `actionCodes`, và
 * trong khoảng chưa deploy thì cột này phải còn chữ chứ không được thành dấu gạch.
 */
function ActionCodes({codes, actionCode}) {
    const list = (Array.isArray(codes) && codes.length ? codes : [actionCode]).filter(Boolean)

    if (!list.length) {
        // D-CR-05: mã action chưa chốt thì hiện dấu gạch, không đoán.
        return <span className="VcMuted">{DASH}</span>
    }

    if (list.length === 1) {
        return <code className="VcActionCode">{list[0]}</code>
    }

    return (
        <Tooltip title={`Công đoạn này ghi nhận ${list.length} mã thao tác — sản lượng cộng cả ${list.length}`}>
            <span className="VcActionCodes">
                {list.map((code) => (
                    <code className="VcActionCode" key={code}>{code}</code>
                ))}
            </span>
        </Tooltip>
    )
}

ActionCodes.propTypes = {
    codes: PropTypes.arrayOf(PropTypes.string),
    actionCode: PropTypes.string,
}

export default ActionCodes
